import React from 'react';

import { Text } from '@rbilabs/universal-components';

import Link from 'components/link';
import { useNavigation } from 'hooks/navigation/use-navigation';

import {
  Card,
  CardBody,
  CardContent,
  CardImage,
  CardImageContainer,
  CardTitle,
  Section,
} from './styled';
import { IPreviewWidgetProps } from './types';

export const PreviewWidget = ({ previewContent }: IPreviewWidgetProps) => {
  const { navigate } = useNavigation();
  return (
    <Section>
      {previewContent.map((card, i) => {
        const {
          titleText,
          bodyText,
          linkText,
          linkURL,
          localizedLinkURL,
          previewImage,
          imageDescription,
        } = card;
        const url = localizedLinkURL?.locale || linkURL || '';

        const shouldRenderLink = !!(linkText && url);

        const navigateToUrl = () => {
          navigate(url);
        };

        return (
          <Card key={`card${i}`} $isFirst={i === 0} $isLast={i === previewContent.length - 1}>
            <CardImageContainer>
              <CardImage image={previewImage.locale} alt={imageDescription?.locale || ''} />
            </CardImageContainer>
            <CardContent>
              {titleText.locale ? <CardTitle>{titleText.locale}</CardTitle> : null}

              {bodyText.locale ? <CardBody>{bodyText.locale}</CardBody> : null}

              {shouldRenderLink ? (
                <Link linkPath={url} onPress={navigateToUrl}>
                  <Text variant="headerThree" color={Styles.color.primary} fontWeight="bold">
                    {linkText.locale}
                  </Text>
                </Link>
              ) : null}
            </CardContent>
          </Card>
        );
      })}
    </Section>
  );
};
